<template>
  <div class="summary-tab" data-testid="summary-tab">
    <div class="summary-tab__layout">
      <div class="summary-tab__left" data-testid="summary-tab__left">
        <TaskSummaryDetails
          :task="task"
          :is-account-recon="isAccountRecon"
          data-testid="summary-tab__details"
        />
        <div
          class="summary-tab__comments-card"
          data-testid="summary-tab__conversation"
        >
          <div class="summary-tab__comments-header">Comments</div>
          <FcConversation
            :conversation-list="conversationList"
            :task="task"
            :loading="commentsLoading"
            @getConversation="$emit('getConversation', $event)"
          />
        </div>
      </div>

      <div class="summary-tab__right" data-testid="summary-tab__right">
        <CycleTaskDetailDependencies
          :blocked-by="task.blockedBy || []"
          :blocking="task.blocking || []"
          :relates="task.relates || []"
          :loading="dependenciesLoading"
          :error="dependenciesError"
          data-testid="summary-tab__dependencies"
          @retry="$emit('retry-dependencies')"
        />
        <TaskSummaryAccounts
          v-if="isAccountRecon"
          :task="task"
          data-testid="summary-tab__accounts"
        />
        <TaskSummarySchedule :task="task" data-testid="summary-tab__schedule" />
        <TaskSummaryAssignment :task="task" data-testid="summary-tab__assignment" />
      </div>
    </div>
  </div>
</template>

<script>
import CycleTaskDetailDependencies from './CycleTaskDetailDependencies.vue';
import TaskSummaryDetails from './TaskSummaryDetails.vue';
import TaskSummarySchedule from './TaskSummarySchedule.vue';
import TaskSummaryAssignment from './TaskSummaryAssignment.vue';
import TaskSummaryAccounts from './TaskSummaryAccounts.vue';
import FcConversation from '@/modules/financialclose/components/FcConversation/FcConversation.vue';
import { taskHasDependencyDetail } from '@/modules/financialclose/utils/taskDependencyDetail';
import './SummaryTab.scss';

export default {
  name: 'SummaryTab',

  components: {
    CycleTaskDetailDependencies,
    TaskSummaryDetails,
    TaskSummarySchedule,
    TaskSummaryAssignment,
    TaskSummaryAccounts,
    FcConversation,
  },

  props: {
    task: { type: Object, required: true },
    conversationList: { type: Array, default: () => [] },
    commentsLoading: { type: Boolean, default: false },
    dependenciesError: { type: Boolean, default: false },
  },

  computed: {
    isAccountRecon() {
      return this.task?.task_type === this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION;
    },

    dependenciesLoading() {
      if (this.dependenciesError) return false;
      return !taskHasDependencyDetail(this.task);
    },
  },
};
</script>
